import React from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { Form, Button, Grid } from 'semantic-ui-react';

// Components
import ErrorAlert from '../../../ErrorAlert';
// @ts-ignore
import SubmittingButton from '../../../SubmittingButton';

// Actions
// @ts-ignore
import { deleteGroup } from '../../../../services/groups/actions';

interface Props {
    groupId: number;
    deleteGroup: Function;
    handleSubmit: Function;
    onClose: Function;
}

export class DeleteGroupForm extends React.PureComponent<Props> {
    handleSubmit = () => {
        const { groupId } = this.props;
        this.props.deleteGroup(groupId);
    };

    render(): React.ReactElement {
        const { handleSubmit, onClose } = this.props;

        return (
            <Form
                onSubmit={handleSubmit(this.handleSubmit)}
                autoComplete="off"
            >
                <ErrorAlert namespace="GROUP_DELETE" />
                <Grid>
                    <Grid.Column mobile={16} tablet={8} computer={8}>
                        <Button
                            type="button"
                            color="grey"
                            onClick={() => onClose()}
                            fluid
                            basic
                            primary
                        >
                            Cancel
                        </Button>
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={8} computer={8}>
                        <SubmittingButton
                            type="submit"
                            namespace="GROUP_DELETE"
                            negative
                            fluid
                        >
                            Delete
                        </SubmittingButton>
                    </Grid.Column>
                </Grid>
            </Form>
        );
    }
}

export default connect(
    null,
    { deleteGroup }
)(
    reduxForm<any, any>({
        form: 'GROUP_DELETE'
    })(DeleteGroupForm)
);
